<template><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 609 660" style="enable-background:new 0 0 609 660;" xml:space="preserve">
<g>
	<g>
		<g>
			<g>
				<path class="st0" d="M304.5,660c-30.7,0-61.5-13.9-109.6-41.7l-85.2-49.2C13.3,513.5,0,490.4,0,379.1v-98.4
					C0,169.6,13.3,146.5,109.7,90.9l85.2-49.2c96.3-55.6,123-55.6,219.3,0l85.2,49.2c96.3,55.6,109.7,78.7,109.7,189.9v98.4
					c0,111.2-13.3,134.3-109.6,189.9l-85.2,49.2C366,646.1,335.2,660,304.5,660z M304.5,28.4c-24.9,0-51.5,12.7-95,37.8l-85.9,49.6
					c-43.5,25.1-67.8,41.8-80.2,63.3c-12.5,21.6-14.7,51-14.7,101.2v99.2c0,50.2,2.3,79.6,14.7,101.2c12.5,21.6,36.8,38.3,80.2,63.3
					l85.9,49.6c43.5,25.1,70.1,37.8,95,37.8s51.5-12.7,95-37.8l85.9-49.6c43.5-25.1,67.8-41.8,80.2-63.3
					c12.4-21.6,14.7-51,14.7-101.2v-99.2c0-50.2-2.3-79.6-14.7-101.2c-12.5-21.6-36.8-38.3-80.2-63.3l-85.9-49.6
					C356,41.2,329.4,28.4,304.5,28.4z"/>
			</g>
		</g>
		<g>
			<g>
				<path class="st0" d="M136.7,297.6h19.5c3.1,0,5.7,1,7.8,3c2.1,2,3.2,4.4,3.2,7.2c0,2.8-1.1,5.2-3.2,7.2c-2.1,2-4.7,3-7.8,3
					h-19.5v24.2H168c3.1,0,5.7,1,7.8,3c2.1,2,3.1,4.4,3.1,7.2c0,2.8-1,5.2-3.1,7.2c-2.1,2-4.7,3-7.8,3h-42.1c-3.1,0-5.7-1-7.8-3
					c-2.1-2-3.1-4.4-3.1-7.2v-88.9c0-2.8,1-5.2,3.1-7.2c2.1-2,4.7-3,7.8-3h40.5c3.1,0,5.7,1,7.8,3c2.1,2,3.2,4.4,3.2,7.2
					c0,2.8-1.1,5.2-3.2,7.2c-2.1,2-4.7,3-7.8,3h-29.6V297.6z"/>
			</g>
			<g>
				<path class="st0" d="M236.6,370.3c-2.1,2-4.7,3-7.8,3c-3.1,0-5.7-1-7.8-3c-2.1-2-3.1-4.4-3.1-7.2v-9.4c-0.4,0.2-0.9,0.4-1.7,0.7
					s-1.2,0.5-1.4,0.6c-2.4,0.7-5,1.1-7.8,1.1c-7.6,0-14.1-2.9-19.4-8.7c-5.3-5.8-8-13.3-8-22.5v-34.3c0-9.2,2.7-16.7,8-22.5
					c5.3-5.8,11.8-8.7,19.4-8.7c2.3,0,4.9,0.4,7.8,1.3c0.2,0.1,1.2,0.4,3.1,1.1v-9.4c0-2.8,1-5.2,3.1-7.2c2.1-2,4.7-3,7.8-3
					c3.1,0,5.7,1,7.8,3c2.1,2,3.2,4.4,3.2,7.2v9.4c1.9-0.7,3-1,3.1-1.1c2.7-0.9,5.3-1.3,7.8-1.3c7.6,0,14.1,2.9,19.4,8.7
					c5.3,5.8,7.9,13.3,7.9,22.5v34.3c0,9.2-2.6,16.7-7.9,22.5c-5.3,5.8-11.7,8.7-19.4,8.7c-2.9,0-5.5-0.4-7.8-1.1
					c-0.2-0.1-0.7-0.3-1.4-0.6s-1.3-0.5-1.7-0.7v9.4C239.7,365.9,238.7,368.3,236.6,370.3z M217.8,281.2c-0.3,0-0.9-0.3-2.1-0.8
					c-1.4-0.5-3-0.8-5-0.8c-2.8,0-5.1,1-6.8,2.9c-1.7,1.9-2.6,4.6-2.6,8v34.3c0,3.5,0.9,6.1,2.6,8.1c1.7,1.9,4,2.9,6.8,2.9
					c1.8,0,3.4-0.3,5-0.8c0.4-0.1,1.1-0.4,2.1-0.8V281.2z M239.7,334.2c1,0.5,1.6,0.8,2,0.8c1.5,0.5,3.2,0.8,5,0.8
					c2.8,0,5.1-1,6.8-2.9c1.7-1.9,2.6-4.6,2.6-8.1v-34.3c0-3.5-0.9-6.1-2.6-8c-1.7-1.9-4-2.9-6.8-2.9c-2,0-3.7,0.3-5,0.8
					c-1.2,0.5-1.8,0.7-2,0.8V334.2z"/>
			</g>
			<g>
				<path class="st0" d="M310.6,326.4v27.3c0,2.8-1,5.2-3.1,7.2s-4.7,3-7.8,3c-3.1,0-5.7-1-7.8-3c-2.1-2-3.1-4.4-3.1-7.2v-90.5
					c0-2.8,1-5.2,3.1-7.2c2.1-2,4.7-3,7.8-3h19.5c10.8,0,19.1,3.1,24.8,9.3c5.8,6.2,8.7,15.4,8.7,27.4s-2.9,21.2-8.7,27.4
					c-5.8,6.2-14.1,9.3-24.8,9.3H310.6z M319.2,306.2c3.4,0,6.1-1.4,8.4-4.2c2.2-2.8,3.4-6.9,3.4-12.2c0-5.3-1.1-9.3-3.4-12.2
					c-2.2-2.8-5-4.2-8.4-4.2h-8.6v32.8H319.2z"/>
			</g>
			<g>
				<path class="st0" d="M361.4,285.8c0-10.9,3.2-19.6,9.6-26.1c6.4-6.5,14.9-9.8,25.5-9.8c4.3,0,8.5,0.8,12.4,2.2
					c4,1.5,7.3,3.4,10,5.7c2.7,2.3,4.8,4.9,6.4,7.6c1.6,2.8,2.4,5.4,2.4,7.9c0,2.8-1.1,5.2-3.2,7.2c-2.1,2-4.7,3-7.8,3
					c-1.8,0-3.5-0.5-4.9-1.4c-1.4-0.9-2.6-2-3.6-3.3c-1-1.3-2-2.6-3-3.9c-1-1.3-2.3-2.4-4-3.3s-3.5-1.4-5.6-1.4
					c-3.7,0-6.5,1.3-8.6,3.8c-2.1,2.5-3.1,6.4-3.1,11.8v43.7c0,10.4,4.2,15.6,12.5,15.6c2,0,3.8-0.5,5.4-1.4c1.6-1,3-2.1,4.1-3.5
					c1.1-1.4,2.3-2.8,3.4-4.2c1.1-1.4,2.4-2.5,3.9-3.5c1.5-1,3.2-1.4,5.1-1.4c3.1,0,5.7,1,7.8,3c2.1,2,3.1,4.4,3.1,7.2
					c0,2.7-0.8,5.5-2.4,8.3c-1.6,2.8-3.8,5.4-6.6,7.8c-2.8,2.4-6.2,4.3-10.4,5.8s-8.6,2.2-13.3,2.2c-10.7,0-19.2-3.2-25.6-9.7
					c-6.4-6.5-9.6-15.2-9.6-26.2V285.8z"/>
			</g>
			<g>
				<path class="st0" d="M469.1,295.2c20.8,0,31.2,11.2,31.2,33.6c0,22.4-10.4,33.5-31.2,33.5h-22.6c-3.1,0-5.7-1-7.8-3
					c-2.1-2-3.1-4.4-3.1-7.2v-88.9c0-2.8,1-5.2,3.1-7.2c2.1-2,4.7-3,7.8-3h37.5c3.1,0,5.7,1,7.8,3c2.1,2,3.1,4.4,3.1,7.2
					c0,2.8-1,5.2-3.1,7.2c-2.1,2-4.7,3-7.8,3h-26.6v21.8H469.1z M457.4,315.5v26.5h11.7c2.9,0,5.2-1.1,6.9-3.2s2.5-5.5,2.5-10
					c0-4.5-0.8-7.9-2.5-10c-1.7-2.2-4-3.2-6.9-3.2H457.4z"/>
			</g>
		</g>
		<g>
			<path class="st0" d="M518.7,473.5H90.2c-14.3,0-25.9-11.6-25.9-25.9V212.3c0-14.3,11.6-25.9,25.9-25.9h428.5
				c14.3,0,25.9,11.6,25.9,25.9v235.3C544.6,461.9,533,473.5,518.7,473.5z M90.2,209.4c-1.6,0-2.9,1.3-2.9,2.9v235.3
				c0,1.6,1.3,2.9,2.9,2.9h428.5c1.6,0,2.9-1.3,2.9-2.9V212.3c0-1.6-1.3-2.9-2.9-2.9H90.2z"/>
		</g>
		<g>
			<path class="st0" d="M485,422.5H128.1c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5H485c6.4,0,11.5,5.1,11.5,11.5
				S491.4,422.5,485,422.5z"/>
		</g>
	</g>
</g>
</svg>
</template>